module.exports = __webpack_public_path__ + "97a5b585d1d675a2e5ee36600222a053.png";